import { APPLIED_JOB_STATUS, GET_JOB_APPLICATIONS } from '../../constants/redux';

export const getJobApplicationsList = (payload) => {
  return {
    type: GET_JOB_APPLICATIONS,
    payload
  };
};

export const applyJobStatus = (payload) => {
  return {
    type: APPLIED_JOB_STATUS,
    payload
  };
};
